var flags = require('../regexp/flags');

var RegExpPrototype = RegExp.prototype;

module.exports = function (it) {
  return (it === RegExpPrototype || it instanceof RegExp) && !('flags' in it) ? flags(it) : it.flags;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/instance/flags.js
// module id = 615
// module chunks = 0